<template>
    <div class="bList bottom50">
        <!-- table组件 -->
        <div class="my_table ">
        
            <div class="my_search">
                <Row class="search_row">  
                    <div  class="search_name">
                        <!-- 首页列表 -->
                        <Button class="mR5" @click="num=0;timeFun()"    :type="num==0?'primary':'text'" >今天</Button>
                        <Button class="mR5" @click="num=1;timeFun()"    :type="num==1?'primary':'text'" >昨天</Button>
                        <Button class="mR5" @click="num=2;timeFun()"    :type="num==2?'primary':'text'" >近7天</Button>
                        <Button class="mR5" @click="num=3;timeFun()"    :type="num==3?'primary':'text'" >近30天</Button>
                        <Button class="mR5" @click="num=4;timeFun()"    :type="num==4?'primary':'text'" >本月</Button>
                        <Button class="mR5" @click="num=5;timeFun()"    :type="num==5?'primary':'text'" >上月</Button>
                        <DatePicker :clearable="false"  split-panels type="daterange" @on-change='dateFun'  v-model="date" placement="bottom-start" placeholder="Select date" style="width: 200px"></DatePicker>                              
                    </div>    
                </Row>  
            </div>

        </div>
        <Table border :columns="columns1" :data="data1"></Table>
        <Footer>
            <Page  :current.sync="page" :page-size-opts=[7,14,21,28,35] :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer />
        </Footer>

    </div>
</template>
<script>
    export default {
        name:'list_child',
        data () {
            return {
                date: null,

                num: 2,
                begin: null,
                end: null,
               
                columns1: [],
                data1: [],
                total: null,
                page: 1,
                size: 7

            }
        },
        computed: {
       
        },
        methods: {
            load(){
                let that = this;
                that.$myAjax.get('admin/service/statistics/index/by/time?begin='+that.begin+'&end='+that.end).then( res => {
                    let dataAll = res.data.data;
                    let data = dataAll.info.reverse();

                    that.columns1 = [
                        {title:'日期 （ '+data.length+' ） ',key:'time',align:'center',width: 260},
                        {title:'新增用户 （ '+dataAll.registerCount+' ）',key:'registerCount',align:'center'},
                        {title:'新增成员 （ '+dataAll.member+' ）',key:'member',align:'center'},
                        {title:'新增家谱 （ '+dataAll.genealogy+' ）',key:'genealogy',align:'center'},
                        {title:'新增会员数  （ '+dataAll.vip+' ）',key:'vip',align:'center'},
                        {title:'订单 （ '+dataAll.order+' ）',key:'order',align:'center'}
                    ]

                    that.data1 = [];
                    
                    that.total = data.length;
                    for(let i = (that.page-1)*that.size;i<that.page*that.size;i++){
                        
                        if(data[i]){
                            that.data1.push({
                                time: data[i].time,
                                registerCount: data[i].registerCount,
                                member: data[i].member,
                                genealogy: data[i].genealogy,
                                vip: data[i].vip,
                                order: data[i].order
                            });
                        }

                    }
                })
            },
            change_page(index){
                this.load();
            },
            change_size(size){
                this.size = size;
                this.load();
            },

            dateFun(data){
                let that = this;
                that.num = null;
                that.begin = data[0];
                that.end = data[1];
                
                that.load();
            },
            timeFun(){
                if(this.num == 0){
                    this.begin = this.$moment().format("YYYY-MM-DD");
                    this.end = this.$moment().format("YYYY-MM-DD");
                    console.log(this.end)
                }else if(this.num == 1){
                    this.begin = this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.end = this.$moment().subtract(1, 'days').format('YYYY-MM-DD');

                }else if(this.num == 2){
                    this.begin = this.$moment().subtract(6, 'days').format('YYYY-MM-DD');
                    this.end = this.$moment().format('YYYY-MM-DD');
                }else if(this.num == 3){
                    this.begin = this.$moment().subtract(29, 'days').format('YYYY-MM-DD');
                    this.end = this.$moment().format('YYYY-MM-DD');
     
                }else if(this.num == 4){
                    this.begin = this.$moment().startOf('month').format("YYYY-MM-DD");
                    this.end = this.$moment().format('YYYY-MM-DD');
                
                }else if(this.num == 5){
                    this.begin = this.$moment().month(this.$moment().month() - 1).startOf('month').format("YYYY-MM-DD");
                    this.end = this.$moment().month(this.$moment().month() - 1).endOf('month').format("YYYY-MM-DD");
                }
                this.date = null;
                this.load();
            }
        },
        mounted: function(){
            var that = this;
            
            that.timeFun();
        }
    }
</script>  
<style scoped>
    @import "/css/modal.css";
</style>
